import { render, staticRenderFns } from "./driver-card-add-processremark-modal.vue?vue&type=template&id=10a4d53e"
import script from "./driver-card-add-processremark-modal.vue?vue&type=script&lang=js"
export * from "./driver-card-add-processremark-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports